<template>
	<div>
		<div class="filters">
			<el-form :inline="true" :model="form" @submit.native.prevent>
				<el-form-item @keyup.enter.native="select">
					<el-input :placeholder="$t('lang.plh.input')+$t('lang.lab_goodName')" clearable v-model="form.name"></el-input>
				</el-form-item>
				<el-button type="primary" @click="select">{{$t('lang.btn_search')}}</el-button>
			</el-form>
		</div>
		<div>
			<el-card>
				<!--  style="margin: 0 auto;width: 50%;" -->
				<el-tooltip slot="header" class="item" effect="dark" placement="right">
					<div slot="content">{{$t('lang.lab_configurationBatchTips')}}</div>
					<el-button size="medium" type="primary" :disabled="multipleSelection.length<2" @click="configurationLabel">{{$t('lang.lab_configurationBatch')}}</el-button>
				</el-tooltip>
				
				<el-table :data="tableData" :row-class-name="tableRowClassName" class="wid100" @selection-change="handleSelectionChange"
					:height="tableData.length > 0 ? 509 : 132">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column type="index" width="50"></el-table-column>
					<el-table-column prop="spuListPic" :label="$t('lang.lab_photograph')">
						<template slot-scope="scope">
							<el-image style="width: 80px; cursor:pointer;" :src="scope.row.spuListPic" fit="fill" @click="imageDetail(scope.row)"></el-image>
						</template>
					</el-table-column>

					<el-table-column prop="spuTitle" :label="$t('lang.lab_goodName')"></el-table-column>
					<!-- <el-table-column prop="skuTitleAttrValue" :label="$t('lang.lab_Type')"></el-table-column> -->
					<el-table-column :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width3">
						<template slot-scope="scope">
							<el-button class="tableButton" @click="openDialog(scope.row)">{{$t('lang.lab_configurationLabel')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
					:page-count="pageCount" :page-size="pageSize" :page-sizes="[10, 20, 30]" layout="sizes, prev, pager, next, jumper" />
			</el-card>
		</div>

		<el-dialog :title="oneOrMore==1?$t('lang.lab_configurationLabel'): $t('lang.lab_configurationBatch')" :visible.sync="dialogTableVisible"
			:close-on-click-modal='false' :showClose="false">
			<el-table :data="tagList" ref="multipleTable" :row-class-name="tableRowClassName" class="wid100" @selection-change="tagHandleSelectionChange"
				:row-key="getRowKeys">
				<el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
				<el-table-column property="Name" :label="$t('lang.lab_labelName')"></el-table-column>
				<el-table-column property="Weight" :label="$t('lang.lab_tabWeight')"></el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">{{$t('lang.btn_backpage')}}</el-button>
				<el-button type="primary" @click="save">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="$t('lang.lab_goodsDetail')" :visible.sync="imageDialog"
			:close-on-click-modal='false' width="70%">
			<div v-html="this.detailHtml" style="text-align:center"></div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name:'/manage/main.sklTagManage',
		data() {
			return {
				pageNo: 1, // 页数
				pageSize: 10, // 每页显示数量
				pageCount: 0, // 总页数
				mallSpuId: '',
				form: {
					name: ''
				},
				tableData: [], // 商品列表
				tagList: [], // 标签列表
				multipleSelection: [],
				tagMultipleSelection: [],
				dialogTableVisible: false,
				
				imageDialog: false,
				detailHtml: '',
				
				oneOrMore: 0
			}
		},
		mounted() {
			this.selectGoodsList()
		},
		methods: {
			// 切换每页显示多少数据
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.selectGoodsList()
			},
			// 翻页
			handleCurrentChange(val) {
				this.pageNo = val
				this.selectGoodsList()
			},
			// 多选
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			tagHandleSelectionChange(val) {
				this.tagMultipleSelection = val
			},
			getRowKeys(row) {
				return row.Id
			},
			// 表格斑马
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			/* 查询商品列表 */
			selectGoodsList() {
				var loading = this.$loading()
				this.$get(`/sklGood?pageNo=${this.pageNo}&pageSize=${this.pageSize}&search=` + this.form.name)
					.then(
						res => {
							console.log(res)
							loading.close()
							this.tableData = res.list
							this.pageCount = res.pageCount
						},
						err => {
							loading.close()
							this.$message.error(err)
						})
			},
			/* 搜索 */
			select() {
				this.pageNo = 1
				this.selectGoodsList()
			},
			/* 查询标签列表 */
			selectTag() {
				var loading = this.$loading()
				this.$get(`/sklTags`)
					.then(
						res => {
							loading.close()
							this.tagList = res.data
						},
						err => {
							loading.close()
							this.$message.error(err)
						})
			},

			imageDetail(row) {
				this.imageDialog = true
				this.$get(`getSklGoodsInfo?mallSpuId=` + row.mallSpuId)
					.then(
						res => {
							this.detailHtml = res.data.rtData.dtObj.detailHtml
						},
						err => {
							this.$message.error(err)
						}
					)
			},

			/* 批量配置 */
			configurationLabel() {
				this.oneOrMore = 2
				this.tagMultipleSelection = []
				this.dialogTableVisible = true
				this.selectTag()
			},
			/* 修改 */
			openDialog(row) {
				this.oneOrMore = 1
				var loading = this.$loading()
				this.tagMultipleSelection = []
				this.selectTag()

				this.mallSpuId = row.mallSpuId
				this.$get(`/getSklGoodsTag?goodsId=${this.mallSpuId}`)
					.then(
						res => {
							loading.close()
							this.tagMultipleSelection = res.Tags
							this.dialogTableVisible = true

							this.$nextTick(() => {
								if (this.tagList !== undefined && this.tagList !== null && this.tagMultipleSelection !== undefined && this.tagMultipleSelection !==
									null) {
									this.tagMultipleSelection.forEach((v, i) => {
										this.tagList.forEach((_v, _i) => {
											if (v === _v.Id) {
												this.$refs.multipleTable.toggleRowSelection(_v, true)
											}
										})
									})
								}
							})
						},
						err => {
							loading.close()
							this.$message.error(err)
						}
					)
			},
			closeDialog() {
				this.dialogTableVisible = false
				this.$refs.multipleTable.clearSelection()
			},
			/* 保存 */
			save() {
				this.dialogTableVisible = false

				var loading = this.$loading()
				var spuIds = []
				var tagIds = []
				for (let i in this.tagMultipleSelection) {
					tagIds.push(this.tagMultipleSelection[i].Id)
				}
				if (this.oneOrMore == 2) {
					for (let i in this.multipleSelection) {
						spuIds.push(this.multipleSelection[i].mallSpuId)
					}

					this.$get(`/saveSklGoodsTag?goods[]=${spuIds}&tags[]=${tagIds}`)
						.then(
							res => {
								this.$refs.multipleTable.clearSelection()
								loading.close()
								this.selectGoodsList()
								this.$message.success(this.$t('lang.lab_save_success'))
							},
							err => {
								this.$refs.multipleTable.clearSelection()
								loading.close()
								this.selectGoodsList()
								this.$message.error(err)
							}
						)
				} else {
					spuIds.push(this.mallSpuId)
					this.$get(`/saveSklGoodsTag?goods[]=${spuIds}&tags[]=${tagIds}`)
						.then(
							res => {
								this.$refs.multipleTable.clearSelection()
								loading.close()
								this.selectGoodsList()
								this.$message.success(this.$t('lang.lab_save_success'))
							},
							err => {
								this.$refs.multipleTable.clearSelection()
								loading.close()
								this.selectGoodsList()
								this.$message.error(err)
							}
						)
				}
			},

		},

	}
</script>

<style lang="scss">
</style>
